import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vShow as _vShow, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "card",
  style: {"width":"28rem"}
}
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center tittle-card" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times fs-4" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "col-sm-12" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["name", "onUpdate:modelValue", "onChange"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  selected: "",
  value: ""
}, "Selecione uma das opções", -1)
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  key: 0,
  class: "col-sm-12 mb-5 pt-2"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-up" }, null, -1)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-down" }, null, -1)
const _hoisted_18 = { class: "d-flex d-flex flex-row-reverse pt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputCustom = _resolveComponent("InputCustom")!
  const _component_MunicipioUfPerfilDados = _resolveComponent("MunicipioUfPerfilDados")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.title), 1),
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeDropDownAndCancel && _ctx.closeDropDownAndCancel(...args))),
          class: "btn btn-icon btn-danger"
        }, _hoisted_6)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field, index) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: index,
          class: "row mb-5"
        }, [
          _createElementVNode("div", _hoisted_8, [
            (field.label)
              ? (_openBlock(), _createElementBlock("label", _hoisted_9, _toDisplayString(field.label) + ":", 1))
              : _createCommentVNode("", true),
            (field.type == 'text')
              ? (_openBlock(), _createBlock(_component_InputCustom, {
                  key: 1,
                  required: "",
                  type: "text",
                  placeholder: field.label,
                  name: field.name,
                  modelValue: _ctx.result[index].value,
                  "onUpdate:modelValue": ($event: any) => ((_ctx.result[index].value) = $event)
                }, null, 8, ["placeholder", "name", "modelValue", "onUpdate:modelValue"]))
              : _createCommentVNode("", true),
            (field.type == 'textDate')
              ? _withDirectives((_openBlock(), _createBlock(_component_InputCustom, {
                  key: 2,
                  placeholder: field.label,
                  name: field.name,
                  pattern: _ctx.validacoes.INTEIRO_MAIOR_1900,
                  modelValue: _ctx.result[index].value,
                  "onUpdate:modelValue": ($event: any) => ((_ctx.result[index].value) = $event)
                }, null, 8, ["placeholder", "name", "pattern", "modelValue", "onUpdate:modelValue"])), [
                  [_directive_mask, '0000']
                ])
              : _createCommentVNode("", true),
            (field.type == 'municipio')
              ? (_openBlock(), _createBlock(_component_MunicipioUfPerfilDados, {
                  key: 3,
                  required: field.required,
                  currentUf: _ctx.uf,
                  "is-filter": true,
                  placeholder: field.label,
                  name: field.name,
                  modelValue: _ctx.result[index].value,
                  "onUpdate:modelValue": ($event: any) => ((_ctx.result[index].value) = $event),
                  ufClass: "col-sm-12",
                  municipioClass: "col-sm-12 mt-5"
                }, null, 8, ["required", "currentUf", "placeholder", "name", "modelValue", "onUpdate:modelValue"]))
              : _createCommentVNode("", true),
            (field.type == 'select')
              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                  key: 4,
                  name: field.name,
                  class: "form-select",
                  "onUpdate:modelValue": ($event: any) => ((_ctx.result[index].value) = $event),
                  onChange: ($event: any) => (_ctx.onChangeSection($event, field.name))
                }, [
                  _hoisted_11,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: option.value,
                      key: option.value
                    }, _toDisplayString(option.text), 9, _hoisted_12))
                  }), 128))
                ], 40, _hoisted_10)), [
                  [_vModelSelect, _ctx.result[index].value]
                ])
              : _createCommentVNode("", true),
            (field.type == 'select-search')
              ? (_openBlock(), _createBlock(_component_Multiselect, {
                  key: 5,
                  class: "select-search",
                  modelValue: _ctx.result[index].value,
                  "onUpdate:modelValue": ($event: any) => ((_ctx.result[index].value) = $event),
                  placeholder: "Selecione um das opçoes",
                  options: field.options,
                  searchable: true,
                  onChange: ($event: any) => (_ctx.onChangeSectionMultiselect($event, field.name))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"]))
              : _createCommentVNode("", true),
            (field.type == 'select-search-on-sync')
              ? (_openBlock(), _createBlock(_component_Multiselect, {
                  key: 6,
                  class: "select-search",
                  modelValue: _ctx.result[index].value,
                  "onUpdate:modelValue": ($event: any) => ((_ctx.result[index].value) = $event),
                  placeholder: 
              field.placeholder ? field.placeholder : 'Digite para pesquisar'
            ,
                  "resolve-on-load": false,
                  delay: 0,
                  options: field.options,
                  searchable: true,
                  onChange: ($event: any) => (_ctx.onChangeSectionMultiselect($event, field.name))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "options", "onChange"]))
              : _createCommentVNode("", true)
          ])
        ])), [
          [_vShow, _ctx.showFieldByIndex(index)]
        ])
      }), 128)),
      (_ctx.fields.length > 4)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("span", {
              class: "btn btn-light-primary w-100",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMoreOptions()))
            }, [
              (_ctx.data.more_options)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                    _createTextVNode(" Mais Opções "),
                    _hoisted_15
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_16, [
                    _createTextVNode(" Menos Opções "),
                    _hoisted_17
                  ]))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
          type: "submit",
          class: "btn btn-primary",
          style: {"margin-left":"15px"}
        }, " Aplicar "),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearAndClose && _ctx.clearAndClose(...args))),
          class: "btn btn-danger"
        }, " Limpar ")
      ])
    ])
  ]))
}